import React, { useState } from "react";
import UiButton from "../Common/UiButton/UiButton";
import "../PartnerManagement/AddPartner/Style.css";
import { Col, Row } from "react-bootstrap";
import TextInput from "../Common/UITextInput/TextInput";
import { Form, Drawer, message, notification, Switch, Input } from "antd";
import UiDropDown from "../Common/UiDropDown/UiDropDown";
import useForm from "../../common/hooks/useForm";
import "../AccessManagement/Addemployees/style.css";
import { connect } from "react-redux";
import useSession from "../CustomLogout/useSession";
import { useDispatch } from "react-redux";
import { saveAddUserDetails } from "../../redux/AddUserDetails/action";
import { useSelector } from "react-redux";
const AddUserDetails = ({ partnerRefresh, setPartnerRefresh, ...props }) => {
  const [form] = Form.useForm();
  const FormItem = Form.Item;

  const dispatch = useDispatch();

  const partnerId = useSelector(
    (state) => state?.auth?.checkLogin?.partnerFirmId
  );

  const { state, onChangeTextHandler, setState } = useForm();

  const [open, setOpen] = useState(false);
  const [btnDisable, setBtnDisable] = useState(false);
  const [mobile, setMobile] = useState("");
  const showDrawer = () => {
    setOpen(true);
    setBtnDisable(false);
  };

  const onClose = () => {
    setOpen(false);
    setBtnDisable(false);
    form.resetFields();
  };
  const handleSessionExpired = useSession();

  const handleChange = (e) => {
    const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 10);
    setMobile(digitsOnly);
  };

  const validateIndianMobile = (_, value) => {
    const regex = /^[6-9]\d{9}$/;
    if (!value || regex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error("Enter a valid mobile number"));
  };

  const handleKeyPress = (e) => {
    if (!/^\d$/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleCreateUser = (data) => {
    const userData = {
      userFirstName: data?.userFirstName,
      userLastName: data?.userLastName,
      emailAddress: data?.emailAddress,
      mobileNo: data?.mobileNo,
      status: data?.activeStatus,
      partnerFirmId: partnerId,
    };

    console.log("object", data, userData);

    // return;

    setBtnDisable(true);
    dispatch(
      saveAddUserDetails({
        values: userData,
        access_token: props.access_token,
      })
    ).then((res) => {
      if (res && res.status === 200) {
        setTimeout(() => {
          message.success("User Added Successfully");
        }, 1000);
        setBtnDisable(false);
        setOpen(false);
        setPartnerRefresh(true);
        form.resetFields();
      }
      if (res?.data?.error || res.message) {
        const errorCode = res?.data?.error?.errorCode || res.errorCode;
        const errorMessage = res?.data?.error?.message || res.message;
        setBtnDisable(false);
        if (errorCode === "403" && res?.data?.error?.logoutStatus) {
          handleSessionExpired();
        } else {
          notification.error({
            message: errorMessage,
            duration: 5,
            placement: "top",
          });
        }
      }
    });
  };

  const handleMobileNumberKeyPress = (event) => {
    const { key, target } = event;
    const isValueExceedingLimit = target.value.length >= 10;

    if ((!/^\d$/.test(key) && key !== ".") || isValueExceedingLimit) {
      event.preventDefault();
    }
  };

  return (
    <div
      className="addpartner-section"
      style={{ textAlign: "end" }}
      id="add-employee-sec"
    >
      <UiButton title="Add User" onClick={showDrawer} />
      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={open}
        className="add-partner-dow"
      >
        <Form
          autoComplete="off"
          form={form}
          name="addEmployee"
          initialValues={{ activeStatus: true }}
          onFinish={handleCreateUser}
        >
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-content-partner"
            >
              <Col md={6} className="addpartnerheading">
                <h2 className="main-heading">User Details</h2>
                <div className="headre-line"></div>
              </Col>
              <Col md={6} className="btn-section mb-sec-ad">
                <h2 onClick={onClose} className="cancel-btn-add">
                  cancel
                </h2>
              </Col>
            </Col>
          </Row>
          <h3 className="sub-text">User Info</h3>
          <Row>
            <Col lg={12} xs={12} md={12} sm={12} className="add-fields-partner">
              <Col md={6} className="mob-sec-eF">
                <FormItem
                  name="userFirstName"
                  label="First Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter First Name",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    maxLength={75}
                    onInput={(e) => {
                      let value = e.target.value;
                      // Remove leading spaces
                      value = value.trimStart();
                      // Allow only alphabets and spaces (no numbers or special characters)
                      value = value.replace(/[^a-zA-Z\s]/g, "");
                      // Ensure no multiple spaces
                      value = value.replace(/\s+/g, " ");

                      e.target.value = value;
                    }}
                    name="userFirstName"
                    value={state.employeeFirstName}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={6} className="mob-sec-eF">
                <FormItem
                  name="userLastName"
                  label="Last Name"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Last Name",
                    },
                  ]}
                >
                  <TextInput
                    type="text"
                    maxLength={75}
                    onInput={(e) => {
                      let value = e.target.value;
                      // Remove leading spaces
                      value = value.trimStart();
                      // Allow only alphabets and spaces (no numbers or special characters)
                      value = value.replace(/[^a-zA-Z\s]/g, "");
                      // Ensure no multiple spaces
                      value = value.replace(/\s+/g, " ");

                      e.target.value = value;
                    }}
                    value={state.employeeLastName}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner"
            >
              <Col md={6}>
                <FormItem
                  name="emailAddress"
                  label="Email Address"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Email",
                    },
                    {
                      type: "email",
                      message: "Enter Valid Email",
                    },
                  ]}
                >
                  <TextInput
                    maxLength={255}
                    type="email"
                    name="emailAddress"
                    onInput={(e) => {
                      if (e.target.value.trim() == "") {
                        e.target.value = e.target.value.trim();
                      }

                      if (e.target.value.trim() !== "") {
                        e.target.value = e.target.value.trimStart();
                      }
                    }}
                    onChange={onChangeTextHandler}
                  />
                </FormItem>
              </Col>
              <Col md={6} className="q-fix">
                <FormItem
                  name="mobileNo"
                  label="Mobile"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Enter Mobile Number",
                    },
                    { validator: validateIndianMobile },
                  ]}
                >
                  <Input
                    value={mobile}
                    onKeyPress={handleKeyPress}
                    onChange={handleChange}
                    maxLength={10}
                    inputMode="numeric"
                    pattern="\d*"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          <h3 className="sub-text">Active Status</h3>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "0px" }}
              className="add-fields-partner"
            >
              <Col
                md={5}
                className=""
                // style={{ marginBottom: "3px", backgroundColor: "red" }}
              >
                <FormItem
                  name="activeStatus"
                  className="swicth-box-margin"
                  valuePropName="checked"
                  // label="Active Status"
                  colon={false}
                >
                  <Switch
                    defaultChecked={true}
                    value={state.activeStatus}
                    checkedChildren="Active"
                    unCheckedChildren="In-Active"
                    className="custom-switch swicth-box-margin"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row>

          {/* <h3 className="sub-text">Active Status</h3>
          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              className="add-fields-partner mob-sec-role"
            >
              <Col md={12} className="select-roleTye-mob ">
                <FormItem
                  name="status"
                  label="Active/In-active"
                  colon={false}
                  rules={[
                    {
                      required: true,
                      message: "Please Select Active Status",
                    },
                  ]}
                >
                  <UiDropDown
                    className="new-role-sec"
                    // onChange={handleChangeSelect}
                    data={activeStatus}
                    placeholder="Select"
                  />
                </FormItem>
              </Col>
            </Col>
          </Row> */}

          <Row>
            <Col
              lg={12}
              xs={12}
              md={12}
              sm={12}
              style={{ marginTop: "10px" }}
              className="add-fields-partner last-btn-sec-changes"
            >
              <Col md={12}>
                <UiButton
                  disabled={btnDisable}
                  type="submit"
                  title="Create User"
                  className="primary-btn"
                />
              </Col>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    saveAddUserDetails: (data) => dispatch(saveAddUserDetails(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddUserDetails);
